module.exports = __webpack_public_path__ + "img/transfer.535ccf88.svg";